module.exports = __webpack_public_path__ + "img/questionbank.0def3d74.png";